import { ArchetypeDefinition } from '../../archetypeTypes';

export const REBELLION_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'trickster',
        name: 'Trickster',
        description: 'Change, exploration, and boundary testing via waves and edges.',
        category: 'Rebellion',
        tags: ['change', 'novelty', 'play'],
        weights: { waveIntensity: 0.4, edgeCount: 0.3, stability: 0.1, linguisticComplexity: 0.2 }
    },
    {
        key: 'outlaw',
        name: 'Outlaw',
        description: 'Disruptive energy challenging rigid structures.',
        category: 'Rebellion',
        tags: ['disruption', 'freedom', 'edge'],
        weights: { waveIntensity: 0.45, stability: 0.1, edgeCount: 0.25, energyLevel: 0.2 }
    }
];


